import { render, staticRenderFns } from "./Genero.vue?vue&type=template&id=72f0d3de"
import script from "./Genero.vue?vue&type=script&lang=js"
export * from "./Genero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports